import { useContext } from 'react';
import { Table } from 'antd';
import { useNavigate } from 'react-router-dom';
import useTabInvoices from './useTabInvoices';
import { ThemeContext } from '../../../../../../contexts/ThemeContext';
import TableCard from '../../../../../../components/TableCard';
import TablePagination from '../../../../../../components/TablePagination';
import ActiveFiltersBar from '../../../../../../components/ActiveFiltersBar';

interface IProps {
    startPeriod?: string;
    endPeriod?: string;
}

export default function TabInvoices({
    startPeriod,
    endPeriod
}: IProps) {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';
    const navigate = useNavigate();

    const {
        columns,
        isLoading,
        tableData,
        handleTableChange,
        handlePaginationChange,
        handleClearAllFilters,
        activeFilterItems,
        tableParams,
        totalInvoices
    } = useTabInvoices({ startPeriod, endPeriod });

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <ActiveFiltersBar
                filters={activeFilterItems}
                onClearAll={handleClearAllFilters}
            />

            <TablePagination
                current={tableParams.pagination.current}
                pageSize={tableParams.pagination.pageSize}
                total={totalInvoices || 0}
                itemName="notas"
                pageSizeOptions={['10', '25', '50', '100']}
                onChange={handlePaginationChange}
            />

            <TableCard>
                <Table
                    rowKey="id"
                    size="middle"
                    className={`modern-data-table ${isDark ? 'modern-data-table-dark' : ''}`}
                    columns={columns}
                    dataSource={tableData}
                    scroll={{ x: 1250 }}
                    loading={isLoading}
                    pagination={false}
                    onChange={handleTableChange}
                    onRow={(record) => ({
                        onClick: () => {
                            navigate(`/nota/detalhes/${record.id}`);
                        },
                        style: {
                            cursor: 'pointer',
                        },
                    })}
                />
            </TableCard>

            <TablePagination
                current={tableParams.pagination.current}
                pageSize={tableParams.pagination.pageSize}
                total={totalInvoices || 0}
                itemName="notas"
                pageSizeOptions={['10', '25', '50', '100']}
                onChange={handlePaginationChange}
            />
        </div>
    );
}
